import { UserGroups } from "./../../../assets/config/models";
import { BeneficiaryDeleteModalComponent } from "./../../components/beneficiary-delete-modal/beneficiary-delete-modal.component";
import { CoreService } from "./../../services/coreService";
import { Component, inject, OnInit, ViewChild } from "@angular/core";
import { AuthService } from "../../services/authService";
import { BeneficiaryEditModalComponent } from "../../components/beneficiary-edit-modal/beneficiary-edit-modal.component";
import {
  MatDialog,
  MatDialogModule,
  MatDialogRef,
} from "@angular/material/dialog";
import { ChangePasswordComponent } from "../../components/change-password/change-password.component";
import { BeneficiaryAddModalComponent } from "../../components/beneficiary-add-modal/beneficiary-add-modal.component";
import { SharedService } from "../../services/sharedService";
import { CommonModule } from "@angular/common";
import { RouterModule } from "@angular/router";
declare var toastr: any;

@Component({
  selector: "app-nav",
  templateUrl: "./nav.component.html",
  styleUrls: ["./nav.component.scss"],
  providers: [AuthService, CoreService],
  standalone: true,
  imports: [CommonModule, MatDialogModule, RouterModule],
})
export class NavComponent implements OnInit {
  public userDetails: any;
  public groupName: string = "";
  groupTypes = UserGroups;
  public jwt: string = "";
  dialogRef!: MatDialogRef<any>;
  domain: any;
  @ViewChild(BeneficiaryEditModalComponent, { static: true })
  beneficiaryEdit!: BeneficiaryEditModalComponent;
  @ViewChild(BeneficiaryDeleteModalComponent, { static: true })
  beneficiaryDelete!: BeneficiaryDeleteModalComponent;
  isPrivateUser: boolean = false;
  isPaymentMethodUser: boolean = false;
  test = [1, 2, 3];

  authService: AuthService = inject(AuthService);
  private readonly coreService: CoreService = inject(CoreService);
  private readonly dialog: MatDialog = inject(MatDialog);
  private readonly ss: SharedService = inject(SharedService);

  ngOnInit() {
    this.domain = this.ss.Domain;
    const userDetails = localStorage.getItem("user_details");

    if (!userDetails) {
      console.log("No User details set");
      return;
    }

    this.userDetails = JSON.parse(userDetails);
    this.isPaymentMethodUser = this.authService.isPaymentMethodUser(
      this.userDetails,
    );
    this.isPrivateUser = this.authService.isPrivateUser(this.userDetails);

    this.groupName = this.userDetails.group;
    this.jwt = localStorage.getItem("jwt")!;
  }

  navigateToDashboard() {
    this.authService.navigateUser(this.userDetails);
  }

  dropdownMenuClicked(id: string) {
    // console.log(id);
    document
      .querySelector("li#" + id + " ul")!
      .classList.toggle("display-block");
    // document.querySelector('li#'+id+' ul').setAttribute("style", "display:block");
  }

  /**
   * password change
   */
  changePassword({
    new_password,
    old_password,
  }: {
    new_password: string;
    old_password: string;
  }) {
    this.authService.changePassword({ old_password, new_password }).subscribe({
      next: () => {
        toastr.success("", "Password changed successfully.", {
          timeOut: 2000,
        });
      },
      error: () => {
        toastr.error("", "Old password is incorrect.", { timeOut: 2000 });
      },
    });
  }

  addBeneficiary(form: any) {
    this.coreService
      .AddBeneficiary(form)
      .then((result) => {
        toastr.success("", "Added beneficiary successfully..", {
          timeOut: 2000,
        });
        this.refreshBeneficiaries();
      })
      .catch((result) => {
        toastr.error("", "Failed to add beneficiary", { timeOut: 2000 });
      });
  }

  deleteBeneficiary({ id }) {
    if (confirm("Are you sure you want to delete beneficiary?")) {
      this.coreService
        .DeleteBeneficiary(id)
        .then((result) => {
          toastr.success("", "Deleted beneficiary successfully..", {
            timeOut: 2000,
          });
          this.refreshBeneficiaries();
        })
        .catch((result) => {
          toastr.error("", "Failed to delete beneficiary", { timeOut: 2000 });
        });
    }
  }

  editBeneficiary(form: any) {
    const { id, title } = form;

    if (!id || !title) {
      toastr.error("", "Invalid beneficiary data", { timeOut: 2000 });
      return;
    }

    this.coreService
      .EditBeneficiary({ title }, id)
      .then(() => {
        toastr.success("", "Edited beneficiary successfully..", {
          timeOut: 2000,
        });

        this.refreshBeneficiaries();
      })
      .catch(() => {
        toastr.error("", "Failed to edit beneficiary", { timeOut: 2000 });
      });
  }

  async refreshBeneficiaries() {
    this.beneficiaryDelete.ngOnInit();
    this.beneficiaryEdit.ngOnInit();
  }

  showModal(source: any) {
    switch (source) {
      case "edit": {
        this.dialogRef = this.dialog.open(BeneficiaryEditModalComponent);
        break;
      }
      case "add": {
        this.dialogRef = this.dialog.open(BeneficiaryAddModalComponent);
        break;
      }
      case "delete": {
        this.dialogRef = this.dialog.open(BeneficiaryDeleteModalComponent);
        break;
      }
      case "password": {
        this.dialogRef = this.dialog.open(ChangePasswordComponent, {
          data: {
            user: this.userDetails,
          },
        });
        break;
      }
      default: {
        break;
      }
    }

    this.dialogRef.afterClosed().subscribe((result) => {
      console.log("Result from modal is", result);
      if (result) {
        this.handleModal(source, result);
      }
    });
  }

  handleModal(source: string, event: any) {
    switch (source) {
      case "edit":
        this.editBeneficiary(event);
        break;

      case "add":
        this.addBeneficiary(event);
        break;

      case "delete":
        this.deleteBeneficiary(event);
        break;

      case "password":
        this.changePassword(event);
        break;
    }
  }
}
